import { CASE_DETAILS_ACTIONS } from "constants";

export function fetchCaseDetail(caseId) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCH_CASE_DETAILS,
        payload: {
            caseId
        }
    };
}
export function fetchedCaseDetail(caseId, caseDetail) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCHED_CASE_DETAILS,
        payload: {
            caseId,
            caseDetail
        }
    };
}
export function failedFetchCaseDetail(caseId, error) {
    return {
        type: CASE_DETAILS_ACTIONS.FAILED_FETCH_CASE_DETAILS,
        payload: {
            caseId,
            error
        }
    };
}

export function fetchCaseAssociates(caseId) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCH_CASE_ASSOCIATES,
        payload: {
            caseId
        }
    };
}
export function fetchedCaseAssociates(caseId, data) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCHED_CASE_ASSOCIATES,
        payload: {
            caseId,
            data
        }
    };
}
export function failedFetchCaseAssociates(caseId, error) {
    return {
        type: CASE_DETAILS_ACTIONS.FAILED_FETCH_CASE_ASSOCIATES,
        payload: {
            caseId,
            error
        }
    };
}

export function addCaseAssociates(caseId, associates, companyId) {
    return {
        type: CASE_DETAILS_ACTIONS.ADD_CASE_ASSOCIATES,
        payload: {
            caseId,
            associates,
            companyId
        }
    };
}
export function addCaseCompanyAssociates(caseId, associates, companyId, companyAssociates, address) {
    return {
        type: CASE_DETAILS_ACTIONS.ADD_CASE_COMPANY_ASSOCIATES,
        payload: {
            caseId,
            associates,
            companyId,
            companyAssociates,
            address
        }
    };
}
export function addedCaseAssociates(caseId, data) {
    return {
        type: CASE_DETAILS_ACTIONS.ADDED_CASE_ASSOCIATES,
        payload: {
            caseId,
            data
        }
    };
}
export function failedAddCaseAssociates(caseId, error) {
    return {
        type: CASE_DETAILS_ACTIONS.FAILED_ADD_CASE_ASSOCIATES,
        payload: {
            caseId,
            error
        }
    };
}

export function deleteCaseAssociates(caseId, associates, companyId) {
    return {
        type: CASE_DETAILS_ACTIONS.DELETE_CASE_ASSOCIATES,
        payload: {
            caseId,
            associates,
            companyId
        }
    };
}
export function deletedCaseAssociates(caseId, data) {
    return {
        type: CASE_DETAILS_ACTIONS.DELETED_CASE_ASSOCIATES,
        payload: {
            caseId,
            data
        }
    };
}
export function updateCaseAssociateStatus(caseId, status){
    return {
        type: CASE_DETAILS_ACTIONS.UPDATE_DELETE_ASSOCIATE_STATUS,
        payload: {
            caseId,
            status
        }
    };
}
export function failedDeleteCaseAssociates(caseId, error) {
    return {
        type: CASE_DETAILS_ACTIONS.FAILED_DELETE_CASE_ASSOCIATES,
        payload: {
            caseId,
            error
        }
    };
}

export function updateCaseDetail(caseId, caseDetail) {
    return {
        type: CASE_DETAILS_ACTIONS.UPDATE_CASE_DETAILS,
        payload: {
            caseId,
            caseDetail
        }
    };
}
export function updatedCaseDetail(caseId, caseDetail) {
    return {
        type: CASE_DETAILS_ACTIONS.UPDATED_CASE_DETAILS,
        payload: {
            caseId,
            caseDetail
        }
    };
}
export function failedUpdateCaseDetail(caseId, error) {
    return {
        type: CASE_DETAILS_ACTIONS.FAILED_UPDATE_CASE_DETAILS,
        payload: {
            caseId,
            error
        }
    };
}

export function fetchCaseDetailFields(caseId) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCH_CASE_DETAIL_FIELDS,
        payload: { caseId }
    };
}
export function fetchedCaseDetailFields(caseId, data) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCHED_CASE_DETAIL_FIELDS,
        payload: { caseId, data }
    };
}
export function failedFetchCaseDetailFields(caseId, error) {
    return {
        type: CASE_DETAILS_ACTIONS.FAILED_FETCH_CASE_DETAIL_FIELDS,
        payload: { caseId, error }
    };
}

// Stores the loaded TVR record so the proceed checklist (which runs in redux
// middleware, away from the credit-checker component) can gate on its
// completeness. Fetched alongside the case detail.
export function fetchedCaseTvr(caseId, tvr) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCHED_CASE_TVR,
        payload: { caseId, tvr }
    };
}

// Mirrors fetchedCaseTvr above: stores the Existing Relationship section's
// Group Info validation result (derived from GroupInfoTable's dedupe rows,
// see components/group-info-table.js:isAllValidated) so the stage 7/8 proceed
// checklist — which runs in redux middleware, away from the credit-checker
// component — can gate on it.
export function setGroupInfoAllValidated(caseId, allValidated) {
    return {
        type: CASE_DETAILS_ACTIONS.SET_GROUP_INFO_ALL_VALIDATED,
        payload: { caseId, allValidated }
    };
}

export function updateCaseDetailFields(caseId, data) {
    return {
        type: CASE_DETAILS_ACTIONS.UPDATE_CASE_DETAIL_FIELDS,
        payload: {
            caseId,
            data
        }
    };
}
export function updatedCaseDetailFields(caseId, data) {
    return {
        type: CASE_DETAILS_ACTIONS.UPDATED_CASE_DETAIL_FIELDS,
        payload: {
            caseId,
            data
        }
    };
}
export function failedUpdateCaseDetailFields(caseId, error) {
    return {
        type: CASE_DETAILS_ACTIONS.FAILED_UPDATE_CASE_DETAIL_FIELDS,
        payload: {
            caseId,
            error
        }
    };
}

export function updateCaseRemarks(caseId, remarks, internalRemarks, isManuallySaved) {
    return {
        type: CASE_DETAILS_ACTIONS.UPDATE_CASE_REMARKS,
        payload: {
            caseId,
            remarks,
            internalRemarks,
            isManuallySaved
        }
    };
}
export function updatedCaseRemarks(caseId, remarks, internalRemarks) {
    return {
        type: CASE_DETAILS_ACTIONS.UPDATED_CASE_REMARKS,
        payload: {
            caseId,
            remarks,
            internalRemarks
        }
    };
}
export function failedUpdateCaseRemarks(caseId, error) {
    return {
        type: CASE_DETAILS_ACTIONS.FAILED_UPDATE_CASE_REMARKS,
        payload: {
            caseId,
            error
        }
    };
}


export function fetchChannelProductStats(caseId) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCH_CHANNEL_PRODUCT_STATS,
        payload: {
            caseId
        }
    };
}

export function fetchedChannelProductStats(caseId, channelProducts) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCHED_CHANNEL_PRODUCT_STATS,
        payload: {
            caseId,
            channelProducts
        }
    };
}

export function failedFetchChannelProductsStats(error) {
    return {
        type: CASE_DETAILS_ACTIONS.FAILED_FETCH_CHANNEL_PRODUCT_STATS,
        payload: {
            error
        }
    };
}


export function updateChannelProductStats(caseId, channelProducts) {
    return {
        type: CASE_DETAILS_ACTIONS.UPDATE_CHANNEL_PRODUCT_STATS,
        payload: {
            caseId,
            channelProducts
        }
    };
}

export function updatedChannelProductStats(caseId, channelProducts) {
    return {
        type: CASE_DETAILS_ACTIONS.UPDATED_CHANNEL_PRODUCT_STATS,
        payload: {
            caseId,
            channelProducts
        }
    };
}

export function failedUpdateChannelProductsStats(caseId, error) {
    return {
        type: CASE_DETAILS_ACTIONS.FAILED_UPDATE_CHANNEL_PRODUCT_STATS,
        payload: {
            caseId,
            error
        }
    };
}

export function addNewChannelProduct(product) {
    return {
        type: CASE_DETAILS_ACTIONS.ADD_NEW_PRODUCT,
        payload: {
            product
        }
    };
}

export function downloadApplicationForm(caseId, application_form) {
    return {
        type: CASE_DETAILS_ACTIONS.DOWNLOAD_APPLICATION_FORM,
        payload: {
            caseId,
            application_form
        }
    };
}

export function downloadedApplicationForm(caseId) {
    return {
        type: CASE_DETAILS_ACTIONS.DOWNLOADED_APPLICATION_FORM,
        payload: {
            caseId
        }
    };
}

export function failedDownloadApplicationForm(caseId) {
    return {
        type: CASE_DETAILS_ACTIONS.FAILED_DOWNLOAD_APPLICATION_FORM,
        payload: {
            caseId
        }
    };
}

export function uploadCompanyLedger(caseId, ledgerData) {
    return {
        type: CASE_DETAILS_ACTIONS.UPDATE_COMPANY_LEDGERS,
        payload: {
            caseId,
            ledgerData
        }
    };
}

export function uploadedCompanyLedger(caseId, data) {
    return {
        type: CASE_DETAILS_ACTIONS.UPDATED_COMPANY_LEDGERS,
        payload: {
            caseId,
            data
        }
    };
}

export function failedUploadCompanyLedger(caseId, error) {
    return {
        type: CASE_DETAILS_ACTIONS.FAILED_UPDATE_COMPANY_LEDGERS,
        payload: {
            caseId,
            error
        }
    };
}

export function updateCaseQuestionnaire(caseId, questionnaire) {
    return {
        type: CASE_DETAILS_ACTIONS.UPDATE_CASE_QUESTIONNAIRE,
        payload: {
            caseId,
            questionnaire
        }
    };
}

export function updatedCaseQuestionnaire(caseId, data) {
    return {
        type: CASE_DETAILS_ACTIONS.UPDATED_CASE_QUESTIONNAIRE,
        payload: {
            caseId,
            data
        }
    };
}

export function failedUpdateCaseQuestionnaire(caseId, error) {
    return {
        type: CASE_DETAILS_ACTIONS.FAILED_UPDATE_CASE_QUESTIONNAIRE,
        payload: {
            caseId,
            error
        }
    };
}

export function downloadCaseQuestionnaire(caseId, data) {
    return {
        type: CASE_DETAILS_ACTIONS.DOWNLOAD_CASE_QUESTIONNAIRE,
        payload: {
            caseId,
            data
        }
    };
}

export function updateCaseType(caseId, caseType) {
    return {
        type: CASE_DETAILS_ACTIONS.UPDATE_CASE_TYPE,
        payload: {
            caseId,
            caseType
        }
    };
}

export function updatedCaseType(caseId, data) {
    return {
        type: CASE_DETAILS_ACTIONS.UPDATED_CASE_TYPE,
        payload: {
            caseId,
            data
        }
    };
}

export function failedUpdateCaseType(caseId, caseType) {
    return {
        type: CASE_DETAILS_ACTIONS.FAILED_UPDATE_CASE_TYPE,
        payload: {
            caseId,
            caseType
        }
    };
}

export function updateProcessingFee(caseId, proecessing_fee_amount) {
    return {
        type: CASE_DETAILS_ACTIONS.MOVE_CASE_TO_LMS,
        payload: {
            caseId,
            proecessing_fee_amount
        }
    };
}


export function fetchCaseBankAccounts(caseId) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCH_CASE_BANK_ACCOUNTS,
        payload: {
            caseId
        }
    };
}
export function fetchedCaseBankAccounts(caseId, data) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCHED_CASE_BANK_ACCOUNTS,
        payload: {
            caseId,
            data
        }
    };
}
export function failedFetchCaseBankAccounts(caseId, error) {
    return {
        type: CASE_DETAILS_ACTIONS.FAILED_FETCH_CASE_BANK_ACCOUNTS,
        payload: {
            caseId,
            error
        }
    };
}

export function addCaseBankAccounts(caseId, bankAccounts) {
    return {
        type: CASE_DETAILS_ACTIONS.ADD_CASE_BANK_ACCOUNTS,
        payload: {
            caseId,
            bankAccounts
        }
    };
}
export function addedCaseBankAccounts(caseId, data) {
    return {
        type: CASE_DETAILS_ACTIONS.ADDED_CASE_BANK_ACCOUNTS,
        payload: {
            caseId,
            data
        }
    };
}
export function failedAddCaseBankAccounts(caseId, error) {
    return {
        type: CASE_DETAILS_ACTIONS.FAILED_ADD_CASE_BANK_ACCOUNTS,
        payload: {
            caseId,
            error
        }
    };
}

export function deleteCaseBankAccounts(caseId, bankAccounts) {
    return {
        type: CASE_DETAILS_ACTIONS.DELETE_CASE_BANK_ACCOUNTS,
        payload: {
            caseId,
            bankAccounts
        }
    };
}
export function deletedCaseBankAccounts(caseId, data) {
    return {
        type: CASE_DETAILS_ACTIONS.DELETED_CASE_BANK_ACCOUNTS,
        payload: {
            caseId,
            data
        }
    };
}
export function failedDeleteCaseBankAccounts(caseId, error) {
    return {
        type: CASE_DETAILS_ACTIONS.FAILED_DELETE_CASE_BANK_ACCOUNTS,
        payload: {
            caseId,
            error
        }
    };
}

export function fetchCaseDocumentChecklist(caseId) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCH_CASE_CHECKLIST,
        payload: {
            caseId
        }
    };
}

export function fetchedCaseDocumentChecklist(caseId, data) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCHED_CASE_CHECKLIST,
        payload: {
            caseId,
            data
        }
    };
}

export function failedFetchCaseDocumentChecklist(caseId, data, error) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCH_CASE_CHECKLIST,
        payload: {
            caseId,
            data
        },
        error
    };
}

export function GstinsearchList(caseId, status) {
    console.log("inside action", caseId, status);
    return {
        type: CASE_DETAILS_ACTIONS.FETCH_GSTIN_SEARCH,
        payload: {
            caseId,
            status
        }
    };
}


export function fetchCaseRemarks(caseId) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCH_CASE_REMARKS,
        payload: {
            caseId,
        }
    };
}
export function fetchedCaseRemarks(caseId, remarks, internalRemarks) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCHED_CASE_REMARKS,
        payload: {
            caseId,
            remarks,
            internalRemarks
        }
    };
}
export function failedFetchCaseRemarks(caseId, error) {
    return {
        type: CASE_DETAILS_ACTIONS.FAILED_FETCH_CASE_REMARKS,
        payload: {
            caseId,
            error
        }
    };
}

export function fetchCaseEnachMandataDetails(caseId, payload) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCH_CASE_NACH_MANDATE_DETAILS,
        payload: {
            caseId,
            payloadData: payload
        }
    };
}

export function fetchedCaseEnachMandataDetails(data, caseId) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCHED_CASE_NACH_MANDATE_DETAILS,
        payload: {
            data,
            caseId
        }
    };
}

export function failedFetchCaseEnachMandataDetails(error) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCH_FAILED_CASE_NACH_MANDATE_DETAILS,
        payload: {
        },
        error
    };
}



export function fetchCaseEnachMandateStatus(caseId) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCH_CASE_ENACH_MANDATE_STATUS,
        payload: {
            caseId
        }
    };
}

export function fetchedCaseEnachMandateStatus(data, caseId, meta = {}) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCHED_CASE_ENACH_MANDATE_STATUS,
        payload: {
            data,
            caseId,
            meta
        }
    };
}

export function failedFetchCaseEnachMandateStatus(error) {
    return {
        type: CASE_DETAILS_ACTIONS.FETCH_FAILED_CASE_ENACH_MANDATE_STATUS,
        payload: {
        },
        error
    };
}